import HttpRequest from '@/libs/axios'
const baseUrl = process.env.VUE_APP_SERVER_DOMAIN
// const baseUrl = 'http://exam.wf.redmirror.cn'
// const baseUrl = 'http://api.ixue985.com:8090' //正式

const axios = new HttpRequest(baseUrl)
export default axios
